import React from 'react';
import { CssStyleProps } from 'src/base/props/CssStyleProps';
import { Text } from 'src/base/texts/Text';

export const H2: React.FC<CssStyleProps> = ({ children, style }) => (
  <Text variant="h2" style={style}>
    {children}
  </Text>
);
